var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.userBalance)?_c('div',{staticClass:"container-fluid"},[_c('h2',[_vm._v(" Movimenti conto: "+_vm._s(_vm.userBalance.nomeConto)+" ")]),_c('movimenti-table',{attrs:{"row-data":_vm.movimenti}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }